import { useAtomValue, useSetAtom } from 'jotai';
import { configurationId } from '../atoms/configuration';

export const useConfigurationId = () => useAtomValue(configurationId);

export const useResetConfigurationId = () => {
  const setConfigurationId = useSetAtom(configurationId);
  return () => setConfigurationId(null);
};
